export const heights = {
  TAG: "30px",
  FIELD_HIGH: "47px",
  FIELD: "40px",
  FIELD_SMALLEST: "33px",
  BUTTON_SMALL: "33px",
  BUTTON_MEDIUM: "40px",
  BUTTON_HIGH: "47px",
};
